<template>
    <div class="projectSlide">
        <div class="projectWrapper" ref="wrapper">
            <a :href="p.url" target="_blank">
                <div class="projectBgWrapper">
                    <div class="projectBgScale rellax" data-rellax-speed="-2">
                        <div class="projectBg" :style="{'background-image': `url(${require('../../assets/images/projects/'+p.fullImage)})`}"></div>
                        <FluidBackground v-if="!isMobile && !isIe" ref="fluidBackground" :image="require('../../assets/images/projects/'+p.fullImage)" :name="p.title"/>
                    </div>
                </div>
                <div class="openDescriptionBtn" @click="showDescription">
                    <div class="open">
                        <span class="icon-info"></span>
                        <span>{{$t('details')}}</span>
                    </div>
                    <div class="close">
                        <span class="icon-close"></span>
                        <span>{{$t('close')}}</span>
                    </div>
                </div>
                <div class="projectInfos rellax" :data-rellax-speed="isSafari ? 0 : 2.5">
                    <h2 class="projectTitle" v-html="setTitle"></h2>
                    <div class="projectNumber">{{setProjectNumber}}</div>
                </div>
            </a>
            <div class="projectFullInfos">
                <div class="secondBg"></div>
                <div class="scrollableContent" ref="scrollableContent">
                    <div class="content">
                        <h3 v-html="setDescriptionTitle"></h3>
                        <ul class="infos">
                            <li>{{p.year}}</li>
                            <li><a :href="p.agencyUrl" target="_blank">{{p.agency}}</a></li>
                            <li>{{$t('frontEnd')}}</li>
                        </ul>
                        <p class="description" v-html="$t(description)"></p>
                        <ul class="projectTags">
                            <template v-for="(tag, i) in p.tags">
                                <li v-if="i == (p.tags.length-1)">{{tag}}</li>
                                <li v-else>{{tag}} - </li>
                            </template>
                        </ul>

                        <ul class="projectAwards">
                            <li v-for="(award, i) in p.awards">
                                <span class="awardType">{{award.type}}</span> - {{award.name}} ({{award.date}})
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <span v-if="index.index === 0" class="scrollIndicator icon-keyboard_arrow_down"></span>
    </div>
</template>

<script>
import {TweenMax} from 'gsap'
import FluidBackground from '../FluidBackground/FluidBackground'
import PerfectScrollbar from 'perfect-scrollbar'
import MobileDetect from 'mobile-detect'
const { detect } = require('detect-browser');

export default {
    name: 'Project',
    data () {
        return {
            p: this.datas.p,
            description: 'projectsList.'+this.index.index+'.description',
            isMobile: true,
            isIe: false,
            isSafari: false
        }
    },
    components: {
        FluidBackground
    },
    props: ['datas', 'index'],
    mounted: function(){
        this.customScroll = new PerfectScrollbar(this.$refs.scrollableContent, {
            suppressScrollX: true,
            maxScrollbarLength: 300
        });

        let md = new MobileDetect(window.navigator.userAgent);
        this.isMobile = md.mobile()

        const browser = detect();
        this.isIe = browser.name == 'ie' || browser.name == 'edge'
        this.isSafari = browser.name == 'safari' || browser.name == 'ios'
    },
    computed: {
        setTitle: function(){
            let title = this.p.title,
                words = title.split('#')

            if(words.length > 1){
                return `<span class="titleLineWrapper">
                            <span class="titleLine firstLine">${words[0]}</span>
                            </span><span class="titleLineWrapper">
                                <span class="titleLine lastLine">${words[1]}</span>
                            </span>`;
            }
            else{
                return `<span class="titleLineWrapper">
                            <span class="titleLine firstLine">${words[0]}</span>
                            </span>`;
            }
        },
        setProjectNumber: function(){
            let number = parseInt(this.index.index, 10)
            return number >= 10 ? number+1 : '0'+(number+1)
        },
        setDescriptionTitle: function(){
            return this.p.title.replace('#', ' ')
        }
    },
    methods: {
        showDescription: function(e){
            e.preventDefault()

            let project = this.$refs.wrapper,
                descriptionWrapper = project.querySelector('.projectFullInfos'),
                secondBg = project.querySelector('.secondBg'),
                projectTitle = descriptionWrapper.querySelector('h3'),
                description = descriptionWrapper.querySelector('.description'),
                infosList = descriptionWrapper.querySelectorAll('.infos'),
                tags = descriptionWrapper.querySelector('.projectTags'),
                awards = descriptionWrapper.querySelectorAll('.projectAwards li'),
                openBtn = project.querySelector('.openDescriptionBtn'),
                openText = openBtn.querySelector('.open'),
                closeText = openBtn.querySelector('.close')

            if(!descriptionWrapper.classList.contains('open')){

                if(!this.isMobile && !this.isIe)
                    this.$refs.fluidBackground.toggleDisplacement(true)

                TweenMax.to(descriptionWrapper, 0.3, {width: '50%', force3D:true, ease: Power2.easeOut})
                TweenMax.to(secondBg, 0.3, {width: '100%', delay: 0.1, ease: Power2.easeOut, onComplete: _ => {
                    TweenMax.staggerTo([projectTitle, infosList, description, tags], 0.3, {y: 0, autoAlpha: 1, ease: Power2.easeOut}, 0.1, _ => {
                        TweenMax.staggerTo(awards, 0.3, {y: 0, autoAlpha: 1, ease: Power2.easeOut}, 0.1)
                    })

                    descriptionWrapper.classList.add('open')
                    this.customScroll.update();
                }})

                TweenMax.staggerTo(project.querySelectorAll('.titleLine'), 0.3, {y: '100%', ease: Power2.easeOut}, 0.05)

                TweenMax.to(openText, 0.5, {top: -100, autoAlpha: 0})
                TweenMax.to(closeText, 0.5, {top: 20, autoAlpha: 1})
            }
            else{
                TweenMax.staggerTo([projectTitle, infosList, description, tags, awards], 0.3, {y: 10, autoAlpha: 0, ease: Power2.easeOut}, 0.1, _ => {
                    TweenMax.to(secondBg, 0.3, {width: 0, ease: Power2.easeOut})

                    if(!this.isMobile && !this.isIe)
                        this.$refs.fluidBackground.toggleDisplacement(false)

                    TweenMax.to(descriptionWrapper, 0.3, {width: 0, force3D:true, delay: 0.1, ease: Power2.easeOut, onComplete: _ => {

                        TweenMax.staggerTo(project.querySelectorAll('.titleLine'), 0.3, {y: '0%', ease: Power2.easeOut}, 0.05)

                        descriptionWrapper.classList.remove('open')
                    }})

                })

                TweenMax.to(openText, 0.5, {top: 20, autoAlpha: 1})
                TweenMax.to(closeText, 0.5, {top: 100, autoAlpha: 0})
            }
        }
    },
    beforeDestroy: function(){
        this.customScroll.destroy();
        this.customScroll = null;
    }
}
</script>

<style lang="scss">
    @import './project';
</style>



// WEBPACK FOOTER //
// src/components/Project/Project.vue